module.exports = __webpack_public_path__ + "static/img/61.23e906d.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/img_right_icon/61.png
// module id = BBw2
// module chunks = 1